<template>
  <section class="home-stories__container">
    <div class="home-stories__column">
      <article class="home-stories">
        <div class="home-stories__image-container">
          <div class="home-stories__label-container">
            <StoriesIcon class="home-stories__label-icon" />
            <span class="home-stories__label">Stories</span>
          </div>
          <BaseImage
            v-if="image"
            :id="image"
            class="home-stories__image"
          />
        </div>
        <div class="home-stories__wrapper">
          <div
            v-if="quote"
            class="home-stories__quote-wrapper"
          >
            <template v-if="quote">
              <span
                aria-hidden="true"
                class="quote__open"
              >
                &ldquo;
              </span>
              <blockquote
                class="home-story__quote"
                v-text="quote"
              />
              <span
                aria-hidden="true"
                class="quote__end"
              >
                &rdquo;
              </span>
            </template>
            <cite
              v-if="title"
              class="home-story__cite"
              v-text="title"
            />
            <LinkButton
              :to="{ name: 'stories'}"
              class="home-stories__link home-stories__link--large"
            > See all stories</LinkButton>
          </div>
        </div>
      </article>
      <LinkButton
        :to="{ name: 'stories' }"
        class="home-stories__link home-stories__link--small"
      >See all stories</LinkButton>
    </div>
  </section>
</template>

<script>
  import Story from '@/api/stories';

  import LinkButton from './LinkButton';
  import StoriesIcon from './StoriesIcon';

  export default {
    components: {
      LinkButton,
      StoriesIcon,
    },
    data() {
      return {
        image: undefined,
        title: undefined,
        quote: undefined,
      };
    },
    async created() {
      const stories = await Story.all();

      const {
        title: { rendered: title },
        acf: {
          quote,
          home_image: image,
        },
      } = stories[Math.floor(Math.random() * stories.length)];

      this.image = image;
      this.title = title;
      this.quote = quote;
    },
  };
</script>

<style
  scoped
  lang="scss"
>
  .home-stories__container {
    @include container;
    padding-bottom: spacing(base-zeta);

    @include breakpoint(phablet) {
      padding-bottom: spacing(base-eta);
    }
  }

  .home-stories__column {
    @include column;
    text-align: center;
  }

  .home-stories {
    //TODO gutters
    padding: 15px;
    position: relative;
    width: 100%;
    background-color: color(bronze);
  }

  .home-stories__wrapper {
    position: relative;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: 100%;
    border: 2px solid color(white);
  }

  .home-stories__image-container {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: calc(75vw - 48px);

    @include breakpoint(phablet) {
      width: 50%;
      height: 100%;
    }
  }

  .home-stories__image {
    position: relative;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .home-story__quote {
    display: inline-block;
    //reset
    margin: 0;
    font-family: font-family(sans-serif);
    font-weight: font-weight(bold);
    font-size: 1.6rem;
    color: color(white);
    text-transform: uppercase;
    letter-spacing: 3px;
    line-height: 2;
    text-align: center;

    @include breakpoint(phablet) {
      font-size: 2.6rem;
      text-align: center;
    }
  }

  .home-stories__quote-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    margin-top: calc(75vw - 48px);
    padding-right: spacing(base-beta);
    padding-bottom: spacing(base-gamma);
    padding-left: spacing(base-beta);

    @include breakpoint(phablet) {
      align-items: center;
      width: percentage(6/12);
      margin-top: 0;
      padding-top: spacing(base-eta);
      padding-right: percentage(1/12);
      padding-bottom: spacing(base-eta);
      padding-left: percentage(1/12);
      height: 100%;
    }
  }

  .quote__open,
  .quote__end {
    height: 25px;
    font-family: font-family(serif);
    font-weight: font-weight(bold);
    font-size: 5.6rem;
    color: color(slate);

    @include breakpoint(phablet) {
      font-size: 7.6rem;
    }
  }

  .quote__open {
    margin-bottom: spacing(base-gamma);

    @include breakpoint(phablet) {
      margin-bottom: spacing(base-delta);
    }
  }

  .quote__end {
    margin-top: spacing(base-gamma);

    @include breakpoint(phablet) {
      margin-top: spacing(base-delta);
    }
  }

  .home-story__cite {
    font-family: font-family(sans-serif);
    font-size: 1.5rem;
    font-style: normal;
    color: color(slate);
    margin-top: spacing(base-gamma);
    text-align: center;


    @include breakpoint(phablet) {
      font-size: 2rem;
      margin-top: spacing(base-delta);
      margin-bottom: spacing(base-delta);
    }
  }

  .home-stories__link {
    color: color(bronze);

    @include breakpoint(phablet) {
      color: color(white);
    }
  }

  .home-stories__link--large {
    display: none;

    @include breakpoint(phablet) {
      display: inline-block;
    }
  }

  .home-stories__link--small {
    display: inline-block;
    margin-top: spacing(base-delta);

    @include breakpoint(phablet) {
      display: none;
    }
  }

  .home-stories__label-container {
    position: absolute;
    top: 0;
    left: 25px;
    z-index: 1;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    transform: rotate(-90deg) translateX(-100%);
    transform-origin: left;
    width: 100%;

    @include breakpoint(phablet) {
      left: 60px;
    }
  }

  .home-stories__label {
    position: relative;
    font-family: font-family(sans-serif);
    font-weight: font-weight(bold);
    font-size: 1.8rem;
    color: color(white);
    text-transform: uppercase;
    letter-spacing: 3px;

    @include breakpoint(phablet) {
      font-size: 3.3rem;
    }
  }

  .home-stories__label-icon {
    width: 25px;
    height: 25px;
    margin-left: spacing(base-beta);
    fill: color(white);

    @include breakpoint(phablet) {
      width: 40px;
      height: 40px;
    }
  }

</style>
